import { Canvas, IEvent } from "fabric/fabric-impl";
import { nodePalette } from "../../../theme";
import simpleCircleGraphics from "../../graphics/SimpleCircleGraphics";
import ManaNode, { ManaNodeOptions } from "./ManaNode";

import { fabric } from "fabric"
import { Box } from "@material-ui/core";
import { Typography } from "@material-ui/core";
import { alpha } from "@material-ui/core";

export type SimpleManaNodeOptions = {
	color?: string
} & ManaNodeOptions

export default class SimpleManaNode extends ManaNode {
	color

	constructor({ color = nodePalette.background, ...rest }: SimpleManaNodeOptions) {
		super(rest)

		this.color = color
	}

	getSymbol() {
		return (this.constructor as any)?.nodeIcon || this.symbol || '❔'
	}

	getTooltip() {

		const { nodeName = '', nodeDesc = '' } = this.constructor as any

		return (
			<Box>
				<Typography color="primary">{nodeName}</Typography>
				<Typography variant="subtitle2" color="textSecondary">{nodeDesc}</Typography>
			</Box>
		)
	}

	reloadSymbol() {
		this.symbol = this.getSymbol()
		if (this.graphics) {
			(this.graphics as any).getObjects().find((o: any) => o.type === 'text').set('text', this.symbol)
		}
	}

	createGraphics() {

		const graphics = simpleCircleGraphics({
			obj: this,
			x: this.position.x,
			y: this.position.y,
			size: this.size,
			symbol: this.symbol,
			color: this.color,
			border: () => {
				if (this.particles.length) return nodePalette.active
				return this.particleIndicationCooldown ? alpha(nodePalette.active, this.particleIndicationCooldown / this.maxParticleIndicationCooldown) : nodePalette.border
			},
			evented: true,
		})

		return graphics
	}

	setSize(size: number) {
		if ((size >= 20) && (size <= 500)) {

			if (this.graphics) {
				const g = this.graphics as any

				const text = g.getComponent('text')
				const circle = g.getComponent('circle')
				const arc = g.getComponent('arc')

				if (arc) {
					arc.set({ radius: (size / 2) + 12 })
				}
				circle.set({ radius: size / 2 })
				text.fontSize = size / 2

				g._restoreObjectsState();
				fabric.util.resetObjectTransform(g);
				g._calcBounds();
				g._updateObjectsCoords();
			}

			super.setSize(size)
		}
	}

	addGraphics(canvas: Canvas) {
		super.addGraphics(canvas)

		if (this.graphics) {
			this.graphics.on('mousedown', (event: IEvent) => {
				if (event.button === 2) {
					this.dispose()
					event.e.preventDefault()
					event.e.stopPropagation()
					return false
				}
			})
		}
	}


}